import { defaultLineItem } from "./lineItems";
import Logger from "../../clients/sentry";

export interface MFUFlookupByDepth {
  [depth: number]: {
    [key: string]: string;
  };
}

export const RESERVED_COLUMN_NAMES_LOWER = new Set(
  [
    ...Object.keys(defaultLineItem),
    "parent",
    "parent_name",
    "type",
    "category",
    "total_plus_markup",
    "markup_allocation",
    "alternateId",
    "alternate",
    "alternate_code",
    "alternate_desc",
    "alternateStatus",
    "baseBid",
    "use_group",
    "floor_group",
    "quantity_take_off",
    "estimate_system",
    "lmseo_prorated",
    "labor_rate_prorated",
    "import_batch",
  ].map((k) => k.toLowerCase())
);

const warnedSortFieldCollisions = new Set<string>();

export function safeSortFieldColumnName(sortFieldName: string, usedColumnNames?: Set<string>): string {
  const candidateKeys = [sortFieldName, `${sortFieldName}_code`, `${sortFieldName}_desc`];
  const collidesWithReserved = candidateKeys.some((k) => RESERVED_COLUMN_NAMES_LOWER.has(k.toLowerCase()));

  let safeName = collidesWithReserved ? `sf_${sortFieldName}` : sortFieldName;

  if (usedColumnNames) {
    let counter = 1;
    let candidate = safeName;
    while (
      usedColumnNames.has(candidate.toLowerCase()) ||
      usedColumnNames.has(`${candidate}_code`.toLowerCase()) ||
      usedColumnNames.has(`${candidate}_desc`.toLowerCase())
    ) {
      counter++;
      candidate = `${safeName}_${counter}`;
    }
    safeName = candidate;
    usedColumnNames.add(safeName.toLowerCase());
    usedColumnNames.add(`${safeName}_code`.toLowerCase());
    usedColumnNames.add(`${safeName}_desc`.toLowerCase());
  }

  if (safeName !== sortFieldName) {
    const warningKey = `${sortFieldName}->${safeName}`;
    if (!warnedSortFieldCollisions.has(warningKey)) {
      warnedSortFieldCollisions.add(warningKey);
      Logger.warn(
        `Sort field "${sortFieldName}" collides with a reserved or duplicate column; using "${safeName}" for column names`
      );
    }
  }
  return safeName;
}
